// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__2_LaP","table":"Table_table__3FyoD","row":"Table_row__F683Z","col":"Table_col__2jGMw","foot":"Table_foot__IN1i3"};